<template>
  <div id="app-2021-04-hallituspaikat">
    <h2 class="app-title">Rakenna hallitus</h2>

    <div class="party-buttons">
      <button
        @click="addParty(party)"
        v-for="party in parties"
        :style="{background: party.color}"
        :class="[regering.includes(party) ? '' : 'inactive']"
        :key="'button-'+party.pid"
      >
        <strong>{{ party.abbr_fi }}</strong>
        <span v-if="party.pid == 5"> ({{ party.seats-1 }} + 1)</span>
        <span v-else> ({{ party.seats }})</span>
      </button>
      <button class="reset-button" @click="regering = []">Aloita alusta</button>
    </div>
    <div class="party-row">
      <div
        v-for="(party, index) in regering"
        class="party-block"
        :style="{background: party.color, width: getWidth(party.seats)}"
        :key="'block-'+party.pid"
      >
        <span v-if="index == regering.length - 1" class="seat-count">{{ seats }}</span>
      </div>
      <div class="half-marker">100 edustajaa</div>
    </div>
    <div v-if="partyNames">
      <div v-if="regering.length > 1" class="result-wrapper">
        <div class="result-text">
          <h4 class="pMargin">
            Olet koonnut
            <em v-if="seats>100">enemmistöhallituksen</em>
            <em v-else>vähemmistöhallituksen</em>,
             jossa on mukana {{ partyNames }}.
          </h4>
          <p class="pMargin">
            Yhteensä teillä on nyt <span class="boldedText">{{ seats }} edustajaa</span>.
            <span v-if="seats < 101">
              Kannattaa valita mukaan vielä lisää puolueita, jotta saisitte paremmat mahdollisuudet edistää politiikkaanne.
            </span>
            <span v-else-if="seats <= 110">
              Se on vain pieni enemmistö, joten puoluekuri on tärkeää. Kaikkien edustajien on äänestettävä hallituksen esitysten puolesta. Muuten on vaarana, että esitykset eivät mene läpi ja hallitus on jopa vaarassa kaatua.
            </span>
            <span v-else>
              Se on vahva enemmistö, mikä tarkoittaa, että hallituksen on helpompi saada eduskunnan tuki esityksilleen. Suomessa on perinteisesti ollut enemmistöhallitus.
            </span>
          </p>
           
        </div>

       
        <template v-if="showAllQuestions">
          <button class="more-button" @click="showAllQuestions = false">Näytä vähemmän</button>
          <QuestionMeter v-for="question in questionSDs" :key="question.id" :question="questions[question.id]" :regering="regering" />
        </template>
        
      </div>
      <div v-else class="result-wrapper">
        <h4>
          Mukana on vasta yksi puolue.
        </h4>
        <p><strong>{{ seats }} edustajaa ei riitä.</strong> Valitse lisää puolueita.</p>
      </div>
    </div>
    <div v-else>
      <h2>Valitse puolueita painikkeista</h2>
    </div>
      <h4>*AT = Eduskuntaryhmä Ano Turtiainen</h4>
    <div>
    </div>
  </div>
</template>

<script>
import parties from './parties.json'
import questions from './questions.json'

import QuestionMeter from './components/QuestionMeter.vue'

const totalSeats = 200;

export default {
  name: 'app',
  data () {
    return {
      parties,
      regering: [],
      questions,
      categories: {
        1: "ilmasto",
        2: "raha",
        3: "terveys",
        4: "perhe ja koulutus",
        5: "maahanmuutto",
        6: "turvallisuus"
      },
      showAllQuestions: false,
    }
  },
  components: {
    QuestionMeter,
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    partyNames() {
      let string = '';
      const length = this.regering.length;

      if (length > 0) {
        for (let i = 0; i < length; i++) {
          if (i < 1) {
            string += this.regering[i].name_fi;
          }
          else if (i < length-1) {
            string += ', ' + this.regering[i].name_fi;
          }
          else {
            string += ' ja ' + this.regering[i].name_fi;
          }
        }
        return string;
      }
      else return null;
    },
    questionScores() {
      if (this.regering.length > 0) {

        let scores = [];
        let parties_agree = 0;
        // loop through all questions
        for (let i = 0; i < this.questions.length; i++) {
          const question = this.questions[i];

          let disagree = 0;
          let agree = 0;
          let neutral = 0;
          // loop through all parties that have been selected and check if they either agree or disagree with the question
          for (let j = 0; j < this.regering.length; j++) {
            if (question[this.regering[j].pid] > 3) {
              agree += 1;
            }
            else if (question[this.regering[j].pid] < 3) {
              disagree += 1;
            }
            else neutral += 1;
          }

          // if all parties either agree or disagree, give a point
          if ((Math.abs(agree - disagree)) == this.regering.length - neutral) {
            parties_agree += 1;
          }

          scores[i] = [
            question.question_sv,
            agree,
            disagree,
            neutral
          ]
        }
        return {
          scores: scores,
          agrees: parties_agree
        };
      }
      else return null;
    },
    questionSDs() {
      if (this.regering.length > 1) {
        let scores = [];
        for (let i = 0; i < this.questions.length; i++) {
          const question = this.questions[i];
          let answers = [];
          for (let j = 0; j < this.regering.length; j++) {
            answers.push(question[this.regering[j].pid]);
          }

          scores.push({
            id: i,
            sd: this.getSD(answers),
            category: question.category,
          });
        }

        scores.sort((a, b) => {return a.sd - b.sd});
        return scores;
      }
      else return null;
    },
    categoryScores() {
      if (this.questionSDs) {
        const grouped = Object.values(this.questionSDs.reduce((result, {
          category,
          sd
        }) => {
          // Create new group
          if (!result[category]) result[category] = {
            id: category,
            sds: []
          };
          // Append to group
          result[category].sds.push(sd);
          return result;
        }, {}));

        let cats = [];

        for (let i = 0; i < grouped.length; i++) {
          const mean = this.getMean(grouped[i].sds);
          cats.push({
            id: grouped[i].id,
            mean: mean,
          });
        }

        cats.sort((a, b) => {return a.mean - b.mean});
        return cats;
      }
      return null;
    },
    seats() {
      let seats = 0;
      for (let j = 0; j < this.regering.length; j++) {
        seats += this.regering[j].seats;
      }
      return seats;
    },
    regeringPids() {
      let ids = [];
      for (let j = 0; j < this.regering.length; j++) {
        ids.push(this.regering[j].pid);
      }
      return ids;
    },
  },
  methods: {
    getWidth(seats) {
      return seats/totalSeats * 100 + '%';
    },
    addParty(party) {
      if (!this.regering.includes(party)) {
        this.regering.push(party);
      }
      else this.regering.splice(this.regering.indexOf(party), 1);
    },
    getMean(data) {
      return data.reduce(function (a, b) {
        return Number(a) + Number(b);
      }) / data.length;
    },
    getSD(data) {
      let m = this.getMean(data);
      return Math.sqrt(data.reduce(function (sq, n) {
        return sq + Math.pow(n - m, 2);
      }, 0) / (data.length - 1));
    },
  },
}
</script>

<style lang="scss">
#app-2021-04-hallituspaikat {
  font-family: "Roboto", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 980px;
  margin: 0 auto;
  background: #fafafa;
  padding: 15px;
  border-radius: 15px;
  word-break: initial;
  line-height: 1.5;

  @media screen and (min-width: 480px) {
    padding: 20px;
  }

  h1, h2, h3, h4 {
    font-family: "Roboto", Arial, sans-serif;
    font-weight: 700;
  }

  h2, h3 {
    text-align: center;
    margin-bottom: 1em;
    margin-top: 1em;
  }

  h2 {
    font-size: 1.4em;
  }

  h3 {
    font-size: 1.3em;
  }

  h4 {
    font-size: 0.75em;
    font-weight: 400;
    color: gray;
    text-align: center;
  }

  h2.app-title {
    margin-top: 0;
    font-size: 1.6em;
  }

  .party-buttons {
    margin-bottom: 2em;

    button {
      color: #fff;
      border-radius: 5px;
      border: 2px solid transparent;
      width: 100px;
      padding: 4px;
      text-align: center;
      margin-right: 6px;
      margin-bottom: 6px;
      font-size: 14px;
      cursor: pointer;
      line-height: 1.5;

      @media screen and (max-width: 419px) {
        width: calc(33% - 6px);
        font-size: 12px;
      }

      &:hover {
        border: 2px solid #000;
      }

      &.inactive {
        opacity: 0.45;
      }

      &.reset-button {
        background: transparent;
        color: #00b5c8;
      }
    }
  }

  .result-wrapper {
    max-width: 600px;
    margin: 0 auto;
  }

  .result-text {
    margin-bottom: 2em;
  }

  .party-row {
    height: 60px;
    width: 100%;
    display: block;
    position: relative;
    background: #fff;
    margin-bottom: 3em;

    .half-marker {
      position: absolute;
      bottom: -2em;
      right: 50%;
      height: 100%;
      padding-right: 8px;
      border-right: 1px solid rgba(0,0,0,0.7);
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      font-size: 12px;
    }

    &:after {
      content: "";
      clear: both;
      display: table;
    }

    .party-block {
      height: 100%;
      float: left;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: center;
      flex-direction: row;

      .seat-count {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        margin-right: 6px;
      }
    }
  }

  .more-button {
    margin: 0 auto 1em;
    display: block;
    background: #fff;
    border: none;
    color: #000;
    border-radius: 5px;
    border: 2px solid transparent;
    padding: 4px 8px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    border: 2px solid #eee;

    &:hover {
      border: 2px solid #999;
    }
  }
}

.ydd-article__body #app-2021-04-hallituspaikat {
  @media screen and (max-width: 499px) {
    margin-left: -20px;
    margin-right: -20px;
  }
}

.boldedText {
  font-weight: 700;
}

.pMargin {
  margin-bottom: 20px;
}
</style>
